import { RebrandHelper } from "../helpers/brand/RebrandHelper";
import React from "react";

export default {
  Title: { Any: "Add a new plan", HOL: "Add a new policy" },
  Description: {
    Any: `You can add any of your ${RebrandHelper.getAxaBrandName()} plans to your online account. To add a new plan, please enter the membership number for the plan you would like to add.`,
    HOL:
      "You can add any of your Health-on-Line policies to your online account. To add a new policy, please enter the membership number for the policy you would like to add."
  },


  MembershipLabel: "Enter your membership number",
  MembershipTooltip:
    "You can find your membership number on your membership documents in the format: AXA/A1234567 or 1234567A. If you can't find it, please call us on 0800 302 9133 and we'll be happy to help.  Lines are open 8am to 8pm, Monday to Friday, and 9am to 5pm Saturday",
  PasswordLabel: "Enter your password",
  Submit: "Submit",
  Errors: {
    MembershipNumberRequired: "Please enter your membership number",
    MembershipNumberInvalid: "Please enter a valid membership number",
    PasswordRequired: "Please enter your password",
    PlanAlreadyAdded: {
      Any: "This plan has already been added to your account.",
      HOL: "This policy has already been added to your account."
    },
    PlanAlreadyRegisteredInSF:"We’ve noticed that you already have an online account",
    RecordNotFoundInSF:
    (
      <React.Fragment>
        <p>
          Unfortunately this plan cannot be added to this account.
          Please try again in 24 hours.
        </p>
      </React.Fragment>
    ),
    ToolTipMFA: {
      Any: (
        <React.Fragment>
          <p>
            You can find your membership number on your membership documents in the format: <strong>AXA/L1234567</strong> or 1234576A. If you can't find it, please call us on 0800 302 9133 and we'll be happy to help.
          </p>
        </React.Fragment>
      ),
      HOL: (
        <React.Fragment>
          <p>
            You can find your membership number on your membership documents in the format: HOL/L1234567. If you can't find it, please call us on 0800 302 9133 and we'll be happy to help.
          </p>
        </React.Fragment>
      )
    },
    UnableToMatchBySystemRecord:
    (
      <React.Fragment>
        <p>
          The details you have entered are incorrect. Please check and try again. If you believe you're entering the correct details and there is still a problem please contact us on 0800 302 9133
        </p>
      </React.Fragment>
    ),
    PlanNotLinkedToSameAccountInSF:
    (
      <React.Fragment>
          <p>
          Unfortunately this plan cannot be added to this account as the account is already linked to another plan.
        </p>
        <p className="mb-0">
        You'll need to create a new account with a different email address, where you will then be able to link this plan to view the details online.
        </p>
        <br></br>
        <p className="mb-0">
          Any questions, please call us on 0800 302 9133.
        </p>
      </React.Fragment>
    ),
    ErrorOccured:
      "The details you have entered are incorrect. Please try again.",
    PlanAlreadyLinkedToOther: {
      Any:
        "The plan cannot be added because it is already linked to another account.",
      HOL:
        "The policy cannot be added because it is already linked to another account."
    }
  }
};
